import styled from '@emotion/styled';

const Container = styled.div({
  margin: '0 auto',
  width: '90%',
  minHeight: 'calc(100vh - 102px)',
});

export default Container;
